import axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  EVENT_CREATE,
  COUNTRY_LIST_DROPDOWN,
  STATE_LIST_DROPDOWN,
  REGION_LIST_DROPDOWN,
  CHAPTER_LIST_DROPDOWN,
} from "../../routes/routes";
import { toast } from "react-toastify";
import defaultIcon from "../../assets/images/defaultimage.png";
import { EVENT_CREATED } from "../../constant/constant";
import { ValidationMessage, hasRole } from "../../components/Utils";
import Select from "react-select";
import Flatpickr from "react-flatpickr";
import { FullPageLoader } from "../../components/common/Loader"; // Import the loader component
import moment from "moment";
import "flatpickr/dist/themes/material_red.css";
import { Image } from "react-bootstrap";
import { Timepicker } from "timepicker-ui-react";
import "timepicker-ui/main.css";
import EventUpiPaymentSection from "./components/EventUpiPaymentSection";

const ChapterCreate = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ payment_currency: "INR" });
  const [errors, setErrors] = useState({});
  const [countryOptions, setCountryOptions] = useState({});
  const [stateOptions, setStateOptions] = useState({});
  const [regionOptions, setRegionOptions] = useState({});
  const [chapterOptions, setChapterOptions] = useState({});
  const [loading, setLoading] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [filter, setFilter] = useState([]);

  const selectStateRef = useRef(null);
  const selectRegionRef = useRef(null);
  const selectChapterRef = useRef(null);

  const handleStateClear = () => {
    if (selectStateRef.current) selectStateRef.current.clearValue();
    if (selectRegionRef.current) selectRegionRef.current.clearValue();
    if (selectChapterRef.current) selectChapterRef.current.clearValue();
  };

  const handleRegionClear = () => {
    if (selectRegionRef.current) selectRegionRef.current.clearValue();
    if (selectChapterRef.current) selectChapterRef.current.clearValue();
  };

  const handleChapterClear = () => {
    if (selectChapterRef.current) selectChapterRef.current.clearValue();
  };

  const auth_user = JSON.parse(localStorage.getItem("user"));

  /**   *
   * @param {*} input
   * @param {*} callback
   */

  const submit = () => {
    setLoading(true);
    setBtnDisabled(true);
    let requestBody = { ...form };
    axios
      .post(EVENT_CREATE, requestBody, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        if (res.status === 201 && res.data.success) {
          toast.success(EVENT_CREATED);
          navigate("/events");
        }
      })
      .catch((err) => {
        if (err.response.status === 422) {
          const error = err.response.data.error;
          setErrors(error);
          toast.error(err.response.data.msg);
        }
      })
      .finally(() => {
        setLoading(false);
        setBtnDisabled(false);
      });
  };

  useEffect(() => {
    if (hasRole([6])) {
      setForm({ ...form, country_id: auth_user?.country_id });
    }

    if (hasRole([7])) {
      setForm({
        ...form,
        country_id: auth_user?.country_id,
        state_id: auth_user?.state_id,
      });
    }

    if (hasRole([2])) {
      setForm({
        ...form,
        country_id: auth_user?.country_id,
        state_id: auth_user?.state_id,
        region_id: auth_user?.region_id,
      });
    }

    if (hasRole([3])) {
      setForm({
        ...form,
        country_id: auth_user?.country_id,
        state_id: auth_user?.state_id,
        region_id: auth_user?.region_id,
        chapter_id: auth_user?.chapter_id,
      });
    }

    const fetchData = async () => {
      try {
        // Fetch country data
        const countryResponse = await axios.get(COUNTRY_LIST_DROPDOWN);
        const fetchedCountryOptions = countryResponse.data.data;
        setCountryOptions(fetchedCountryOptions);

        // Fetch state data
        const stateResponse = await axios.get(STATE_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedStateOptions = stateResponse.data.data;
        setStateOptions(fetchedStateOptions);

        // Fetch region data
        const regionResponse = await axios.get(REGION_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedRegionOptions = regionResponse.data.data;
        setRegionOptions(fetchedRegionOptions);

        // Fetch chapter data
        const chapterResponse = await axios.get(CHAPTER_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedChapterOptions = chapterResponse.data.data;
        setChapterOptions(fetchedChapterOptions);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [filter]);
  return (
    <div className="content-wrapper">
      <FullPageLoader visible={loading || btnDisabled} />
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h5 className="page-title">Events</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#212b39"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                      </svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <Link to={"/events"}>
                    <span>Events List</span>
                  </Link>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <span className="active_breadcrumb">Create Event</span>
                </li>
              </ol>
            </div>
            <div className="col-lg-6">
              <div className="pt-btn">
                <Link to={"/events"}>
                  <button type="button" className="btn btn-dark igoback_btn">
                    <i className="bx bx-exit"></i> back
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        <div className="row">
          <div className="col-xl-12">
            <div className="card mb-4">
              <div className="card-header d-flex justify-content-between align-items-center"></div>
              <div className="card-body">
                <form>
                  <div className="row">
                    {hasRole([1]) && (
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="country_id" className="form-label">
                            Country<span className="text-danger">*</span>
                          </label>
                          <Select
                            name="country_id"
                            isClearable
                            options={countryOptions}
                            onChange={(selected) => {
                              handleStateClear();
                              setForm({
                                ...form,
                                country_id: Number(selected?.value),
                                state_id: null,
                                region_id: null,
                                chapter_id: null,
                              });
                              setFilter({
                                ...filter,
                                country_id: selected?.value,
                                state_id: null,
                                region_id: null,
                                chapter_id: null,
                              });
                            }}
                          />
                          <ValidationMessage error={errors} name="country_id" />
                        </div>
                      </div>
                    )}

                    {hasRole([1, 6]) && (
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="state_id" className="form-label">
                            State<span className="text-danger">*</span>
                          </label>
                          <Select
                            ref={selectStateRef}
                            name="state_id"
                            isClearable
                            options={stateOptions}
                            onChange={(selected) => {
                              handleRegionClear();
                              setForm({
                                ...form,
                                state_id: Number(selected?.value),
                                region_id: null,
                                chapter_id: null,
                              });
                              setFilter({
                                ...filter,
                                state_id: selected?.value,
                                region_id: null,
                                chapter_id: null,
                              });
                            }}
                          />
                          <ValidationMessage error={errors} name="state_id" />
                        </div>
                      </div>
                    )}

                    {hasRole([1, 6, 7]) && (
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="region_id" className="form-label">
                            Region<span className="text-danger">*</span>
                          </label>
                          <Select
                            isClearable
                            ref={selectRegionRef}
                            options={regionOptions}
                            onChange={(selected) => {
                              handleChapterClear();
                              setForm({
                                ...form,
                                region_id: Number(selected?.value),
                                chapter_id: null,
                              });
                              setFilter({
                                ...filter,
                                region_id: selected?.value,
                                chapter_id: null,
                              });
                            }}
                          />
                          <ValidationMessage error={errors} name="region_id" />
                        </div>
                      </div>
                    )}

                    {hasRole([1, 6, 7, 2]) && (
                      <div className="col-6">
                        <div className="mb-3">
                          <label className="form-label" htmlFor="chapter_id">
                            Chapter
                          </label>
                          <Select
                            isClearable
                            ref={selectChapterRef}
                            options={chapterOptions}
                            onChange={(selected) => {
                              setForm({ ...form, chapter_id: selected?.value });
                            }}
                          />
                          <ValidationMessage error={errors} name="chapter_id" />
                        </div>
                      </div>
                    )}

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="event_date">
                          Event Date<span className="text-danger">*</span>
                        </label>
                        <Flatpickr
                          className="form-control"
                          options={{
                            dateFormat: "Y-m-d",
                            enableTime: false,
                            onChange: (selected) =>
                              setForm({
                                ...form,
                                event_date: moment(selected[0]).format(
                                  "YYYY-MM-DD",
                                ),
                              }),
                          }}
                          placeholder="Select Event Date"
                        />
                        <ValidationMessage error={errors} name="event_date" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="from_time">
                          From Time<span className="text-danger">*</span>
                        </label>
                        <Timepicker
                          id="from_time"
                          className="form-control"
                          placeholder="Select From Time"
                          options={{
                            clock: { type: "12h" },
                            ui: { clearButton: true },
                          }}
                          onConfirm={(data) => {
                            const hour = data?.hour;
                            const minutes = data?.minutes;
                            const type = data?.type; // "AM" or "PM" for 12h
                            let timeStr = `${hour}:${minutes} ${type}`;
                            const formatted = moment(timeStr, [
                              "h:mm A",
                              "HH:mm",
                            ]).format("HH:mm:ss");
                            setForm({ ...form, from_time: formatted });
                          }}
                          onClear={() => {
                            setForm({ ...form, from_time: "" });
                          }}
                        />
                        <ValidationMessage error={errors} name="from_time" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="to_time">
                          To Time<span className="text-danger">*</span>
                        </label>
                        <Timepicker
                          id="to_time"
                          className="form-control"
                          placeholder="Select To Time"
                          options={{
                            clock: { type: "12h" },
                            ui: { clearButton: true },
                          }}
                          onConfirm={(data) => {
                            const hour = data?.hour;
                            const minutes = data?.minutes;
                            const type = data?.type; // "AM" or "PM" for 12h
                            let timeStr = `${hour}:${minutes} ${type}`;
                            const formatted = moment(timeStr, [
                              "h:mm A",
                              "HH:mm",
                            ]).format("HH:mm:ss");
                            setForm({ ...form, to_time: formatted });
                          }}
                          onClear={() => {
                            setForm({ ...form, to_time: "" });
                          }}
                        />
                        <ValidationMessage error={errors} name="to_time" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="event_title">
                          Event Title<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control hide-arrow"
                          id="event_title"
                          placeholder="Event Title"
                          onChange={(e) =>
                            setForm({ ...form, event_title: e.target.value })
                          }
                        />
                        <ValidationMessage error={errors} name="event_title" />
                      </div>
                    </div>

                    <div className="col-6">
                      <div className="d-flex justify-content-between">
                        <label htmlFor="image_path" className="form-label">
                          Event Image(16:9)
                          <span className="text-danger">*</span> (ex.
                          1920wx1080h)
                        </label>
                        <div className="d-flex gap-3 image-info">
                          <div>
                            <label>Max :</label>
                            <span>2MB</span>
                          </div>
                        </div>
                      </div>
                      <input
                        type="file"
                        className="form-control"
                        accept="image/jpeg, image/png, image/jpg"
                        onChange={(e) =>
                          e.target.files.length > 0
                            ? setForm({
                                ...form,
                                image_path: e.target.files[0],
                                cardImage: URL.createObjectURL(
                                  e.target.files[0],
                                ),
                              })
                            : ""
                        }
                      />
                      <div className="m-3">
                        <Image
                          width={120}
                          src={form?.cardImage ? form?.cardImage : defaultIcon}
                        />
                      </div>
                      <ValidationMessage error={errors} name="image_path" />
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="event_description"
                        >
                          Event Description
                          <span className="text-danger">*</span>
                        </label>
                        <textarea
                          type="text"
                          className="form-control hide-arrow"
                          id="event_description"
                          rows="6"
                          placeholder="Event description"
                          onChange={(e) =>
                            setForm({
                              ...form,
                              event_description: e.target.value,
                            })
                          }
                        />
                        <ValidationMessage
                          error={errors}
                          name="event_description"
                        />
                      </div>
                    </div>

                    <EventUpiPaymentSection
                      form={form}
                      setForm={setForm}
                      errors={errors}
                    />

                    <div className="demo-inline-spacing d-flex justify-content-end">
                      <Link to={"/events"}>
                        <button
                          type="button"
                          className="btn btn-primary iclose_btn"
                        >
                          Close
                        </button>
                      </Link>
                      <button
                        disabled={btnDisabled}
                        type="submit"
                        className="btn btn-success isubmit_button"
                        onClick={() => submit()}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChapterCreate;
